import React, {Component} from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    InputGroup,
    InputGroupAddon
} from 'reactstrap';
import {SingleDatePicker} from 'react-dates'
import {_createNewCoupon} from "../../../../../../services/apis/AdminCouponServices";

class ModalCreateCoupon extends Component {
    state = {
        modal: false,
        description: '',
        code: '',
        plans: ['starter', 'standard', 'standard-drs', 'pod-drs'],
        type: 'percent_off',
        sale: 0,
        duration: 'Forever',
        duration_in_months: 1,
        has_max_redemptions: false,
        has_expired_at: false,
        max_redemptions: -1,
        expired_at: null
    }

    componentDidUpdate() {
        this.dataSync();
    }

    toggle = () => {
        if (this.state.modal) {
            this.props.toggle.hideModalNewCoupon();
        } else {
            this.props.toggle.showModalNewCoupon();
        }
    }

    setDefaultState = () => {
        this.setState({
            modal: false,
            description: '',
            code: '',
            type: 'percent_off',
            plans: ['starter', 'standard', 'standard-drs', 'pod-drs'],
            sale: 0,
            duration: 'Forever',
            duration_in_months: 1,
            has_max_redemptions: false,
            has_expired_at: false,
            max_redemptions: -1,
            expired_at: null
        });
    }

    handleChangeDescription = (e) => {
        const value = e.target.value;
        this.setState({
            description: value
        });
    }

    handleChangeCode = (e) => {
        const value = e.target.value;
        this.setState({
            code: value
        });
    }

    handleChangeType = (e) => {
        const value = e.target.value;

        this.setState({
            type: value
        })
    }

    handleCheckboxPlans = (e) => {
        const value = e.target.value;
        let plans = this.state.plans;

        const index = plans.indexOf(value)

        if (index === -1) {
            plans.push(value)
        } else {
            if (plans.length > 1) {
                plans.splice(index, 1)
            }
        }

        this.setState({
            plans: plans
        })
    }

    handleChangeSale = (e) => {
        const value = e.target.value;

        this.setState({
            sale: value
        });
    }

    handleChangeDuration = (e) => {
        const value = e.target.value;

        this.setState({
            duration: value,
            duration_in_months: 1
        });
    }

    handleChangeDurationInMonths = (e) => {
        const value = e.target.value;

        this.setState({
            duration_in_months: value
        })
    }

    handleCheckboxLimits = (e) => {
        const value = e.target.value;

        this.setState({
            [value]: !this.state[value]
        });
    }

    handleChangeMaxRedemptions = (e) => {
        const value = e.target.value;

        this.setState({
            max_redemptions: value
        })
    }

    handleFocus = (e) => {
        e.target.select();
    }

    createNewCoupon = () => {
        let amount_off = 0, percent_off = 0;
        let {description, code, duration, duration_in_months, type, sale, max_redemptions, expired_at, plans} = this.state;
        if (type === "percent_off") percent_off = sale;
        if (type === "amount_off") amount_off = sale;
        duration = duration.toLocaleLowerCase();

        _createNewCoupon({
            description,
            code,
            duration,
            duration_in_months,
            amount_off,
            percent_off,
            max_redemptions,
            expired_at,
            plans
        })
            .then(result => {
                // console.log(result);
                this.setDefaultState();
                this.props.toggle.hideModalNewCoupon();
                this.props.toggle.fetchListCoupons();
            })
            .catch(err => {
                // console.log(err.mesages);
            });
    }

    dataSync() {
        const {modal, duration, duration_in_months, has_max_redemptions, has_expired_at, max_redemptions, expired_at} = this.state;

        if (modal !== this.props.modal) {
            this.setState({
                modal: this.props.modal
            });
        }

        if (duration !== 'Repeating' && duration_in_months !== 1) {
            this.setState({
                duration_in_months: 1
            });
        }

        if (!has_max_redemptions && max_redemptions !== -1) {
            this.setState({
                max_redemptions: -1
            });
        }

        if (!has_expired_at && expired_at != null) {
            this.setState({
                expired_at: null
            });
        }
    }

    render() {
        const {description, code, type, sale, duration, duration_in_months, has_max_redemptions, has_expired_at, max_redemptions, expired_at, plans} = this.state;
        const titleSale = type === "percent_off" ? "Percent off:" : "Amount off:";
        const currencyUnit = type === "percent_off" ? "%" : "$";

        return (
            <div className="ModalCoupon">
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>New Coupon</ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup>
                                <Label for="NewCouponCode">Coupon code: </Label>
                                <Input type="text" id="NewCouponCode" onChange={this.handleChangeCode} value={code}/>
                            </FormGroup>

                            <FormGroup>
                                <Label for="NewCouponDescription">Description: </Label>
                                <Input type="text" id="NewCouponDescription" placeholder="First purchase discount"
                                       onChange={this.handleChangeDescription} value={description}/>
                            </FormGroup>

                            <FormGroup>
                                <Label>Apply for:</Label>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={plans.indexOf('starter') !== -1}
                                               onChange={this.handleCheckboxPlans}
                                               value="starter"/>
                                        Starter
                                    </Label>
                                </FormGroup>

                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={plans.indexOf('standard') !== -1}
                                               onChange={this.handleCheckboxPlans}
                                               value="standard"/>
                                        Standard POD
                                    </Label>
                                </FormGroup>

                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={plans.indexOf('standard-drs') !== -1}
                                               onChange={this.handleCheckboxPlans}
                                               value="standard-drs"/>
                                        Standard Dropship
                                    </Label>
                                </FormGroup>

                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={plans.indexOf('pod-drs') !== -1}
                                               onChange={this.handleCheckboxPlans}
                                               value="pod-drs"/>
                                        POD + Dropship
                                    </Label>
                                </FormGroup>
                            </FormGroup>

                            <FormGroup tag="fieldset">
                                <Label>Type:</Label>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="radio" name="radioPercentage" checked={type === "percent_off"}
                                               value="percent_off" onChange={this.handleChangeType}/>{' '}
                                        Percentage discount
                                    </Label>
                                </FormGroup>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="radio" name="radioPercentage" checked={type === "amount_off"}
                                               value="amount_off" onChange={this.handleChangeType}/>{' '}
                                        Fixed amount discount
                                    </Label>
                                </FormGroup>
                            </FormGroup>

                            <FormGroup>
                                <Label for="NewCouponSale">{titleSale}</Label>
                                <InputGroup>
                                    <Input type="number" min="0" id="NewCouponSale" onChange={this.handleChangeSale}
                                           value={sale} onFocus={this.handleFocus}/>
                                    <InputGroupAddon addonType="append">{currencyUnit}</InputGroupAddon>
                                </InputGroup>
                            </FormGroup>

                            <FormGroup>
                                <Label for="NewCouponDuration">Duration:</Label>
                                <Input type="select" name="select" id="NewCouponDuration" value={duration}
                                       onChange={this.handleChangeDuration}>
                                    <option>Forever</option>
                                    <option>Once</option>
                                    <option>Repeating</option>
                                </Input>
                            </FormGroup>

                            {
                                duration === 'Repeating' && (<FormGroup>
                                    <Label for="DurationInMonths">Duration in months:</Label>
                                    <InputGroup>
                                        <Input type="number" min="0" id="DurationInMonths"
                                               onChange={this.handleChangeDurationInMonths} value={duration_in_months}
                                               onFocus={this.handleFocus}/>
                                    </InputGroup>
                                </FormGroup>)
                            }

                            <FormGroup>
                                <Label>Redemption limits:</Label>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={has_expired_at}
                                               onClick={this.handleCheckboxLimits} value="has_expired_at"/>{' '}
                                        Limit the date range when customers can redeem this coupon
                                    </Label>
                                </FormGroup>

                                {
                                    has_expired_at && (<SingleDatePicker
                                        date={expired_at} // momentPropTypes.momentObj or null
                                        onDateChange={date => this.setState({expired_at: date})} // PropTypes.func.isRequired
                                        focused={this.state.focused} // PropTypes.bool
                                        onFocusChange={({focused}) => this.setState({focused})} // PropTypes.func.isRequired
                                        id="RedemptionLimits" // PropTypes.string.isRequired,
                                    />)
                                }

                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={has_max_redemptions}
                                               onClick={this.handleCheckboxLimits} value="has_max_redemptions"/>{' '}
                                        Limit the total number of times this coupon can be redeemed
                                    </Label>
                                </FormGroup>

                                {
                                    has_max_redemptions && (<FormGroup>
                                        <Label for="ExpiredLimit">Total redemption:</Label>
                                        <InputGroup>
                                            <Input type="number" id="ExpiredLimit"
                                                   onChange={this.handleChangeMaxRedemptions} value={max_redemptions}
                                                   onFocus={this.handleFocus}/>
                                        </InputGroup>
                                    </FormGroup>)
                                }
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.createNewCoupon}>Create</Button>{' '}
                        <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalCreateCoupon;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/coupon/CouponPage/components/ModalCreateCoupon.js